const base = "cui-searchinput-6wut";
const classes = {
  base
};
export {
  base,
  classes as default
};
